import { ReactNode, RefObject, createContext, useContext, useRef } from 'react';
import { ScrollView } from 'react-native';

export const CardBlockScrollContext = createContext<RefObject<ScrollView> | null>(null);

interface Props {
  children: ReactNode;
}

export function CardBlockScrollProvider({ children }: Props) {
  const scrollView = useRef<ScrollView>(null);
  return (
    <CardBlockScrollContext.Provider value={scrollView}>{children}</CardBlockScrollContext.Provider>
  );
}

export function useCardBlockScrollContext() {
  return useContext(CardBlockScrollContext);
}
